import { Button, Form, Input, Spin, notification, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { get, put } from "../../../services";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const FaqForm = () => {
  const { id } = useParams(); 
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [loader2, setLoader2] = useState(false);
  const [information, setInformation] = useState({});

  // useEffect to get content
  useEffect(() => {
    get(`/user/${id}`)
      .then((response) => {
        setInformation(response?.data);
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
      });
    // eslint-disable-next-line
  }, []);

  // notification handler
  const openNotification = (message, description) => {
    notification.open({
      message: message,
      description: description,
    });
  };

  const onFinish = (values) => {
    setLoader2(true);
    const payload = {
      email: values?.email,
      name: values?.name,
      role: values?.role,
    };
    if (values?.password) {
      payload.password = values.password;
    }
    put(`/user/${id}`, payload)
      .then(() => {
        setLoader2(false);
        navigate("/admin");
        openNotification("Success", "Updated Successfully");
      })
      .catch((error) => {
        setLoader2(false);
        openNotification("Error", "");
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <div className="header">
        <h3>Edit Admin</h3>
      </div>
      {!loader ? (
        <div className="form_container">
          <Form
            layout="vertical"
            initialValues={{
              // links
              name: information?.name,
              email: information?.email,
              role: information?.role,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Form.Item
              name="name"
              label="Name"
              rules={[{ required: true, message: "Please enter your Name" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="email"
              label="Email"
              rules={[{ required: true, message: "Please enter your Email" }]}
            >
              <Input type="email" />
            </Form.Item>
            <Form.Item
              name="role"
              label="Role"
              rules={[{ required: true, message: "Please select role" }]}
            >
              <Select
                options={[
                  { value: "", label: "Select Role" },
                  { value: "admin", label: "Admin" },
                  {
                    value: "property_management",
                    label: "Sub Admin (Limited Access)",
                  },
                  {
                    value: "event_operator",
                    label: "Event Manager",
                  },
                ]}
              />
            </Form.Item>
            <Form.Item name="password" label="Password">
              <Input.Password />
            </Form.Item>
            <Form.Item>
              <div className="form_submit">
                <Button className="back_button" onClick={() => navigate("/")}>
                  Back
                </Button>
                <Button htmlType="submit">
                  {loader2 ? "wait..." : "Save"}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      ) : (
        <div className="spin_information">
          <Spin />
        </div>
      )}
    </>
  );
};
export default FaqForm;
